import Icon from '../components/Icon.vue'

Icon.register({
  'spray-can': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M224 32v96h-128v-96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32zM480 128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM224 160c53 0 96 43 96 96v224c0 17.7-14.3 32-32 32h-256c-17.7 0-32-14.3-32-32v-224c0-53 43-96 96-96h128zM160 416c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zM480 96c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM384 128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM288 32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM384 32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM480 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spray-can.js
// module id = 1937
// module chunks = 0